import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import queryString from 'query-string';
import { IMark, IModel } from '../../types'
import axiosBaseQuery from './API'

interface IMarkData {
  delete: any,
  result:IMark[],
  count:number
}
interface IModelData {
  delete: any,
  result:IModel[],
  count:number
}
// Define a service using a base URL and expected endpoints
export const markApi = createApi({
  reducerPath: 'markApi',
  tagTypes: ['Marks'],
  baseQuery: axiosBaseQuery({ baseUrl: process.env.REACT_APP_API_KEY }),
  endpoints: (builder) => ({
    getMark: builder.query<IMarkData, {}>({
      query: (data:any) => {
        const stringified = queryString.stringify(data);
        return  {url:`marks/all/?${stringified}`, method:'GET'}
      },
      providesTags: [{ type: 'Marks' }],
    }),
    addMark: builder.mutation<IMark, Partial<IMark>>({
      query(body) {        
        return {
          url: `marks`,
          method: 'POST',
          data:body,
        }
      },
      invalidatesTags: [{ type: 'Marks'}],
    }), 
    deleteMark: builder.mutation<IMark, {id:number | null}>({
      query({id}) {        
        return {
          url: `marks/${id}`,
          method: 'DELETE',
        }
      },
      invalidatesTags: [{ type: 'Marks'}],
    }), 
  }),
  
})
export const modelApi = createApi({
  reducerPath: 'modelApi',
  tagTypes: ['Model'],
  baseQuery: axiosBaseQuery({ baseUrl: process.env.REACT_APP_API_KEY }),
  endpoints: (builder) => ({
    getModel: builder.query<IModelData,{}>({
      query: (data) => {
        const stringified = queryString.stringify(data);
       return {url:`models/all?${stringified}`, method:'GET'}},
      providesTags: [{ type: 'Model' }],
    }),
    addModel: builder.mutation<IModel, Partial<IModel>>({
      query(body) {
        return {
          url: `models`,
          method: 'POST',
          data:body,
        }
      },
      invalidatesTags: [{ type: 'Model'}],
    }),
    deleteModel: builder.mutation<IMark, {id:number | null}>({
      query({id}) {        
        return {
          url: `models/${id}`,
          method: 'DELETE',
        }
      },
      invalidatesTags: [{ type: 'Model'}],
    }),  
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetMarkQuery, useAddMarkMutation, useDeleteMarkMutation } = markApi
export const { useGetModelQuery, useAddModelMutation, useDeleteModelMutation } = modelApi